<template>
  <div data-automation="setup-python">
    <h1
      :style="{marginTop: 0, marginBottom: '30px'}"
    >
      PyPI "simple" client setup
    </h1>
    <p>
      Before you begin, check to see if pip is already configured to use this repository.  Run <code>pip config list</code>
      in your terminal (not in a Python prompt) and look for the <code>global.index-url</code> configuration value to see where pip
      will look for packages.  If nothing shows up for the index-url setting, or if you'd like to change it, choose
      a repository URL below, and read on.
    </p>

    <div>
      <b>NOTE:</b> The <code>pip</code> command may differ depending on your local python installation. If the <code>pip</code> command is
      not found, try the <code>pip3</code> command instead. This name historically existed to allow Python 2 and 3 to
      coexist on the same system. If you have <code>pip3</code>, but lack <code>pip</code>, you may want to alias the
      <code>pip3</code> command to <code>pip</code>.
    </div>

    <UpsiDatePicker
      :force-binaries-disabled="true"
      :url-suffix="'simple'"
      @repoURL="childRepoURL => { repoURL = childRepoURL }"
    />

    <h2
      data-automation="setup-configure-pip-header"
    >
      Configuring pip to use your repo URL
    </h2>
    <p
      data-automation="setup-configure-pip-para"
    >
      Your repo URL can be used either as a one-off setting in a pip install command, or as a configuration
      setting that affects all of your pip commands.
    </p><div class="textWithButton">
      <h3>
        <span
          data-automation="setup-oneoff-url-label"
          style="font-size: .7em; padding-left: 5px;"
        >One-off</span>
      </h3>
      <div>
        <button
          class="copyButton"
          data-clipboard-target="#addRepoOneOff"
          data-automation="setup-oneoff-copy-button"
        >
          Copy
        </button>
      </div>
    </div>
    <pre
      id="addRepoOneOff"
      data-automation="setup-oneoff-url"
    ><span>pip install --index-url {{ repoURL }} package-you-want-to-install</span></pre>
    <div class="textWithButton">
      <h3>
        <span
          data-automation="setup-persistent-url-label"
          style="font-size: .7em; padding-left: 5px;"
        >Persistent</span>
      </h3>
      <div>
        <button
          class="copyButton"
          data-clipboard-target="#addRepoPersistent"
          data-automation="setup-persistent-copy-button"
        >
          Copy
        </button>
      </div>
    </div>
    <pre
      id="addRepoPersistent"
      data-automation="setup-persistent-repo-url"
    ><span>pip config set global.index-url {{ repoURL }}</span></pre>
    <p>
      The
      <a
        href="https://pip.pypa.io/en/stable/topics/configuration/#configuration-files"
        data-automation="setup-pip-doc"
      >
        pip documentation
      </a> has more information
      about how to set this parameter at different scopes, and the hierarchy of the pip configuration. Most IDEs follow
      this setting. You may also be interested in the instructions for setting a PyPI repo in
      <a
        href="https://www.jetbrains.com/help/pycharm/installing-uninstalling-and-upgrading-packages.html#install-package"
        data-automation="setup-pycharm"
      >
        PyCharm
      </a> and
      <a
        href="https://support.rstudio.com/hc/en-us/articles/360047694373-Configure-a-different-Python-Package-Repository-for-RStudio-Connect"
        data-automation="setup-connect"
      >RStudio Connect</a>.
    </p>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { serverPath } from '../../api/http-common'
import * as types from '../../store/mutation-types'
import UpsiDatePicker from '../UpsiDatePicker'

const URL_LATEST = 'latest'
const URL_FROZEN = 'frozen'

export default {
  name: 'OverviewPython',
  components: {
    UpsiDatePicker,
  },
  data: function () {
    return {
      URL_LATEST: URL_LATEST,
      URL_FROZEN: URL_FROZEN,
      userRepoName: 'RSPM',
      whichURL: URL_LATEST,
      selectedTransactionDate: null,
      showPackagesInfo: false,
      showSystemDependenciesInfo: false,
      showChangeOSDialog: false,
      showLocalTZ: false,
      selectedDate: new Date(),
      // We store this state in the child component. It emits an event when it changes.
      repoURL: '',
    }
  },
  computed: {
    ...mapState({
      currentRepoId: state => state.repos.currentRepoId,
    }),
    ...mapGetters([
      'currentRepo',
    ]),
    // this is a separate property to cache and avoid calling serverPath multiple times
    pmServerURL: function () {
      return serverPath()
    },
    docURL: function () {
      return `${this.pmServerURL}__docs__/admin`
    },
  },
  watch: {
    currentRepoId: function (value) {
      this.whichURL = URL_LATEST
    },
  },
  mounted: function () {
    this.$store.commit(types.SET_CURRENT_NAV, 'overview')
  },
}

</script>
